if (typeof ScrollingText !== "function") {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			var ScrollingText = (function () {
				function getWidth(element) {
					var rect = element.getBoundingClientRect();
					return rect.right - rect.left;
				}

				function ScrollingText(box, speed) {
					var inner_element = (box.children && box.children[0]) || null;
					if (!inner_element) throw "No child node found";

					inner_element.style.position = "relative";

					this.position = 0;
					this.speed = speed;
					this.box_width = getWidth(box);
					this.inner_element_width = getWidth(inner_element);
					this.box = box;
					this.inner_element = inner_element.cloneNode(true);
					setUpChildrens.call(this);
				}

				function refreshWidths() {
					this.box_width = getWidth(this.box);
					this.inner_element_width = getWidth(this.box.children[0]);
				}

				function calculateNumElements() {
					if (!this.inner_element_width || this.inner_element_width <= 0) return 1;
					var qty = Math.ceil(this.box_width / this.inner_element_width) + 1;
					return Math.min(qty, 50);
				}

				function setUpChildrens() {
					var qty = calculateNumElements.call(this);
					if (qty > this.box.children.length) {
						for (var i = this.box.children.length; i < qty; i++)
							this.box.appendChild(this.inner_element.cloneNode(true));
					} else if (qty < this.box.children.length) {
						for (var i = qty; i < this.box.children.length; i++)
							this.box.removeChild(this.box.lastChild);
					}
				}

				function nextFrame(delta, direction) {
					var self = this;
					refreshWidths.call(this);
					setUpChildrens.call(this);
					Array.prototype.forEach.call(this.box.children, function (el) {
						if (direction == "rtl") {
							el.style.transform = `translateX(${self.position}px)`;
						} else {
							el.style.transform = `translateX(${-self.position}px)`;
						}
					});
					this.position += (this.speed * delta) / 1000;
					if (this.position >= this.inner_element_width)
						this.position = this.position % this.inner_element_width;
				}

				ScrollingText.prototype = {
					start: function (direction, speed) {
						this._running = true;
						var self = this;
						var last_time = null;
						var loop_func = function () {
							if (!self._running) return;
							var now = Date.now();
							var delta = last_time === null ? 0 : now - last_time;
							nextFrame.call(self, delta, direction, speed);
							last_time = now;
							window.requestAnimationFrame(loop_func);
						};
						window.requestAnimationFrame(loop_func);
					},

					stop: function () {
						this._running = false;
					},

					render: function (direction) {
						var self = this;
						Array.prototype.forEach.call(this.box.children, function (el) {
							if (direction == "rtl") {
								el.style.transform = `translateX(${self.position}px)`;
							} else {
								el.style.transform = `translateX(${-self.position}px)`;
							}
						});
					},

					setPosition: function (direction, newPosition) {
						refreshWidths.call(this);
						setUpChildrens.call(this);
						var width = this.inner_element_width || 1;
						this.position = ((newPosition % width) + width) % width;
						this.render(direction);
					},
				};

				return ScrollingText;
			})();

			const speed = window.innerWidth > 768 ? parseInt(this.dataset.scrollingSpeed) : parseInt(this.dataset.scrollingSpeed) / 1.5;
			const direction = this.dataset.scrollingDirection;
			const scrolling_text = new ScrollingText(this, speed, direction);
			// scrolling_text.start(direction);

			const scrollerEl = this;
			const dragTrack = scrollerEl.querySelector('.scrolling-images');

			let momentumRAF = null;
			let resumeTimeout = null;

			function stopMomentum() {
				if (momentumRAF) {
					window.cancelAnimationFrame(momentumRAF);
					momentumRAF = null;
				}
			}

			function clearResumeTimeout() {
				if (resumeTimeout) {
					clearTimeout(resumeTimeout);
					resumeTimeout = null;
				}
			}

			function startMomentum(initialVelocity) {
				stopMomentum();
				scrolling_text.stop();
				var velocity = initialVelocity;
				var lastTime = null;
				var FRICTION = 0.94;
				var MIN_VELOCITY = 0.02;

				function step(now) {
					if (lastTime === null) lastTime = now;
					var dt = now - lastTime;
					lastTime = now;

					if (Math.abs(velocity) < MIN_VELOCITY) {
						momentumRAF = null;
						scrolling_text.start(direction);
						return;
					}

					scrolling_text.setPosition(direction, scrolling_text.position + velocity * dt);
					velocity *= Math.pow(FRICTION, dt / 16.67);
					momentumRAF = window.requestAnimationFrame(step);
				}
				momentumRAF = window.requestAnimationFrame(step);
			}

			if (dragTrack) {
				let isDragging = false;
				let isHorizontalDrag = null;
				let dragStartX = 0;
				let dragStartY = 0;
				let dragStartPosition = 0;
				let activePointerId = null;
				let lastMoveTime = 0;
				let lastMovePosition = 0;
				let velocity = 0;

				scrollerEl.style.touchAction = 'pan-y';
				scrollerEl.style.cursor = 'grab';

				const onPointerDown = function (e) {
					if (e.pointerType === 'mouse' && e.button !== 0) return;
					stopMomentum();
					isDragging = true;
					isHorizontalDrag = null;
					dragStartX = e.clientX;
					dragStartY = e.clientY;
					dragStartPosition = scrolling_text.position;
					activePointerId = e.pointerId;
					lastMoveTime = performance.now();
					lastMovePosition = dragStartPosition;
					velocity = 0;
					scrolling_text.stop();
					clearResumeTimeout();
					scrollerEl.style.cursor = 'grabbing';
					if (e.target.setPointerCapture && e.pointerId !== undefined) {
						try { e.target.setPointerCapture(e.pointerId); } catch (err) {}
					}
				};

				const onPointerMove = function (e) {
					if (!isDragging || (activePointerId !== null && e.pointerId !== activePointerId)) return;
					const deltaX = e.clientX - dragStartX;
					const deltaY = e.clientY - dragStartY;

					if (isHorizontalDrag === null && (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3)) {
						isHorizontalDrag = Math.abs(deltaX) > Math.abs(deltaY);
					}
					if (isHorizontalDrag === false) return;
					if (isHorizontalDrag === true && e.cancelable) e.preventDefault();

					const directionSign = direction === 'rtl' ? 1 : -1;
					scrolling_text.setPosition(direction, dragStartPosition + directionSign * deltaX);

					const now = performance.now();
					const dt = now - lastMoveTime;
					if (dt > 0) {
						const width = scrolling_text.inner_element_width || 1;
						let rawPositionDelta = scrolling_text.position - lastMovePosition;
						if (rawPositionDelta > width / 2) rawPositionDelta -= width;
						if (rawPositionDelta < -width / 2) rawPositionDelta += width;
						velocity = rawPositionDelta / dt;
					}
					lastMoveTime = now;
					lastMovePosition = scrolling_text.position;
				};

				const onPointerUp = function () {
					if (!isDragging) return;
					isDragging = false;
					isHorizontalDrag = null;
					activePointerId = null;
					scrollerEl.style.cursor = 'grab';

					if (Math.abs(velocity) > 0.02) {
						startMomentum(velocity);
					} else {
						resumeTimeout = setTimeout(function () {
							scrolling_text.start(direction);
						}, 400);
					}
				};

				scrollerEl.addEventListener('pointerdown', onPointerDown);
				window.addEventListener('pointermove', onPointerMove, { passive: false });
				window.addEventListener('pointerup', onPointerUp);
				window.addEventListener('pointercancel', onPointerUp);

				let wheelIdleTimeout = null;
				const onWheel = function (e) {
					const absX = Math.abs(e.deltaX);
					const absY = Math.abs(e.deltaY);
					if (absX === 0 && absY === 0) return;
					// Only hijack genuinely horizontal gestures (shift+wheel, trackpad
					// horizontal swipe). Let vertical wheel scrolling pass through
					// untouched so the page keeps scrolling normally over this element.
					if (absY >= absX) return;
					const rawDelta = e.deltaX;
					if (e.cancelable) e.preventDefault();

					stopMomentum();
					scrolling_text.stop();
					clearResumeTimeout();

					scrolling_text.setPosition(direction, scrolling_text.position + rawDelta);
					velocity = rawDelta / 16.67;

					clearTimeout(wheelIdleTimeout);
					wheelIdleTimeout = setTimeout(function () {
						startMomentum(velocity);
					}, 120);
				};

				scrollerEl.addEventListener('wheel', onWheel, { passive: false });
			}

			if(this.dataset.pauseOnHover == "true") {
				const carusel = this;
				let windowInFocus = true;

				window.addEventListener("blur", function() {
					windowInFocus = false;
				});

				window.addEventListener("focus", function() {
					windowInFocus = true;
				});

				carusel.addEventListener('mouseover', isMouseOver);
				carusel.addEventListener('mouseout', isMouseOut);


				function isMouseOver() {
					if (windowInFocus) {
						stopMomentum();
						clearResumeTimeout();
						scrolling_text.stop();
					}
				}

				function isMouseOut() {
					if (windowInFocus) {
						stopMomentum();
						clearResumeTimeout();
						scrolling_text.start(direction);
					}
				}

			}

			const intersectionObserver = new IntersectionObserver(entries => {
				if ( entries[0].isIntersecting ) {
					scrolling_text.start(direction);
				} else {
					stopMomentum();
					clearResumeTimeout();
					scrolling_text.stop();
				}
			});
			intersectionObserver.observe(this);


		}
	}

	if (typeof customElements.get("scrolling-text") == "undefined") {
		customElements.define("scrolling-text", ScrollingText);
	}
}
